import Passport from '../passport/Passport';

export function getCurrentQuestionValue(code) {
  const cv = Passport.Form.values;
  return cv[code];
}